export default "__VITE_ASSET__sPsiROKK__"